import React from 'react';
import { NotFoundPage } from 'sarsaparilla';
import AppContainer from './App';

import OrderDetailsPage from '../src/containers/OrderDetailsPage';

import routesArray from './routesArray';

const Components = {
    OrderDetailsPage
};

export default function routes2() {
    const childRoutes = routesArray.map((route) => {
        const Component = Components[route.componentName];
        return {
            ...route,
            component: (props) => <Component {...props} />
        };
    });
    
    // Append operational routes
    childRoutes[childRoutes.length] = {
        path: '*',
        component: NotFoundPage,
        title: 'Page Not Found'
    };
    
    // add index route and finalize
    const ret = {
        path: '/',
        component: AppContainer,
        childRoutes
    };

    return ret;
}
